import React, { Component } from 'react';

import { navigate } from '@reach/router';
import { isMobile } from 'react-device-detect';

import { ICourse } from '../../../../store/admin/courses/store';
import { IEventRound } from '../../../../store/admin/eventRounds/store';
import { IAdminEventsStore } from '../../../../store/admin/events/store';
import { IAdminRoundFormatsStore, IMetaFormat } from '../../../../store/admin/roundFormats/store';

import List from '../../../../components/Lists/List/List';
import { withContext } from '../../../../contrib/utils';
import { EventWizardStepTitle } from '../Components/EventWizardStepTitle/EventWizardStepTitle';
import { IEventWizardActions } from '../types';
import RoundDetails from './RoundDetails';
import { StyledEventRounds } from './EventRounds.Styles';
import { EVENT_SETUP_SECTIONS } from '../EventSetup/Utils/EVENT_SETUP_SECTIONS';

interface IProps {
  actions: IEventWizardActions;
  adminEvents: IAdminEventsStore;
  adminRoundFormats: IAdminRoundFormatsStore;
  adminCourses: ICourse[];
  eventId: string;
  clubId: string;
}

interface IState {
  selectedRound: number;
  validFormatDrafts: boolean;
}

class EventRoundsComponent extends Component<IProps, IState> {
  public refs = {};

  constructor(props: IProps) {
    super(props);

    this.state = {
      selectedRound: -1,
      validFormatDrafts: true
    };

    this.props.actions.adminCourses.all();
  }

  public setRef = (roundId: number) => (ref: any) => {
    if (ref) {
      this.refs = {
        ...this.refs,
        [roundId]: ref
      };
    }
  };

  public onFormatUpdate = (roundFormatDrafts: IMetaFormat[]) => {
    this.setState({ validFormatDrafts: !(roundFormatDrafts.length > 0) });
  };

  public onSelectRound = (index: number) => {
    const { adminEvents, eventId } = this.props;

    const event = adminEvents[Number(eventId)];

    const rounds = event.rounds;
    this.setState({ selectedRound: rounds[index].id });
  };

  public onSave = async () => {
    const { clubId, eventId } = this.props;
    const promises: any = [];

    Object.values(this.refs).forEach((ref: any) => {
      if (!ref.state.pristine && !ref.state.errors.FORM) {
        promises.push(ref.props.onSubmit(ref.state.values)());
      }
    });

    await Promise.all(promises);

    const nextSectionSlug = EVENT_SETUP_SECTIONS[EVENT_SETUP_SECTIONS.rounds + 1];

    navigate(`/staff/club/${clubId}/event/${eventId}/setup/${nextSectionSlug}`);
  };

  public render(): JSX.Element {
    const {
      actions,
      adminRoundFormats,
      adminRoundFormats: { masterFormats },
      clubId,
      eventId,
      adminEvents,
      adminCourses
    } = this.props;
    const { validFormatDrafts, selectedRound } = this.state;

    const event = adminEvents[Number(eventId)];

    const rounds = event ? event.rounds : [];

    const listContext = {
      actions,
      adminRoundFormats,
      clubId,
      courses: adminCourses,
      event,
      masterFormats,
      onFormatUpdate: this.onFormatUpdate,
      roundDrafts: {},
      rounds,
      selectedRound,
      setRef: this.setRef
    };

    const listFilters = rounds.map((round: IEventRound) => ({
      callback: (item: IEventRound) => item.order === round.order,
      label: `Round ${round.order + 1}`
    }));

    return (
      <StyledEventRounds className="event-wizard-page form round-details">
        <EventWizardStepTitle
          buttonText="SAVE & CONTINUE"
          buttonDisabled={!validFormatDrafts}
          title="ROUND DETAILS"
          buttonOnClick={this.onSave}
        />

        {rounds.length > 0 ? (
          <List
            buttonSetClassName={isMobile ? '-left' : '-centered'}
            context={listContext}
            items={rounds}
            renderItem={RoundDetails}
            filters={rounds.length > 1 ? listFilters : undefined}
            onSelect={this.onSelectRound}
            staffContext={true}
          />
        ) : (
          <div>No rounds found</div>
        )}
      </StyledEventRounds>
    );
  }
}

const EventRounds = withContext(
  EventRoundsComponent,
  'adminEvents',
  'adminRoundFormats',
  'adminCourses'
);

export { EventRounds, EventRoundsComponent };
